import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { contactoSchema } from './schemas/contacto.schema';
import { AdminFormsModule } from './admin-forms.module';
import { FormSubmitEvent, FormChangeEvent } from './models/form-output.model';

@Component({
  selector: 'app-test-form',
  standalone: true,
  imports: [CommonModule, AdminFormsModule],
  template: `
    <div style="padding: 20px; max-width: 800px; margin: 0 auto;">
      
      <h2>Prueba del Sistema de Formularios Dinámicos</h2>
      <p>Este es un ejemplo de uso real del componente DynamicFormComponent</p>
      
      <!-- Datos iniciales -->
      <div class="mb-4 p-3 bg-gray-100 rounded">
        <h4>Datos iniciales:</h4>
        <pre>{{ datosIniciales | json }}</pre>
      </div>
      
      <!-- Formulario dinámico -->
      <app-dynamic-form
        [schema]="contactoSchema"
        [data]="datosIniciales"
        (formSubmit)="onGuardar($event)"
        (formChange)="onCambio($event)"
        (formCancel)="onCancelar()">
      </app-dynamic-form>
      
      <!-- Estado del formulario -->
      <div class="mt-6 p-4 border rounded">
        <h4>Estado del formulario:</h4>
        <div><strong>Último cambio:</strong></div>
        <pre class="text-sm">{{ ultimoCambio | json }}</pre>
        
        <div><strong>Estado del formulario:</strong></div>
        <div *ngIf="estadoFormulario">
          <span [class]="estadoFormulario.valid ? 'valid' : 'invalid'">{{ estadoFormulario.valid ? '✅ Válido' : '❌ Inválido' }}</span>
          <span [class]="estadoFormulario.dirty ? 'dirty' : 'pristine'">{{ estadoFormulario.dirty ? '📝 Modificado' : '✨ Sin cambios' }}</span>
        </div>
        
        <div><strong>Datos para guardar:</strong></div>
        <pre class="text-sm">{{ datosParaGuardar | json }}</pre>
      </div>
      
    </div>
  `,
  styles: [`
    .mb-4 { margin-bottom: 1rem; }
    .mt-6 { margin-top: 1.5rem; }
    .p-3 { padding: 0.75rem; }
    .p-4 { padding: 1rem; }
    .bg-gray-100 { background-color: #f5f5f5; }
    .border { border: 1px solid #ddd; }
    .rounded { border-radius: 0.375rem; }
    .text-sm { font-size: 0.875rem; }
    pre { 
      background: #f8f9fa; 
      padding: 8px; 
      border-radius: 4px; 
      overflow-x: auto; 
      margin: 8px 0;
    }
    h4 { 
      font-size: 1rem; 
      font-weight: 600; 
      margin-bottom: 0.5rem; 
    }
    .valid { 
      color: #155724; 
      background: #d4edda; 
      padding: 2px 6px; 
      border-radius: 3px; 
      margin-right: 8px;
    }
    .invalid { 
      color: #721c24; 
      background: #f8d7da; 
      padding: 2px 6px; 
      border-radius: 3px; 
      margin-right: 8px;
    }
    .dirty { 
      color: #856404; 
      background: #fff3cd; 
      padding: 2px 6px; 
      border-radius: 3px; 
      margin-right: 8px;
    }
    .pristine { 
      color: #155724; 
      background: #d4edda; 
      padding: 2px 6px; 
      border-radius: 3px; 
      margin-right: 8px;
    }
  `]
})
export class TestComponent {

  // Schema del formulario
  contactoSchema = contactoSchema;
  
  // Datos iniciales para el formulario
  datosIniciales = { 
    nombre: 'Juan Pérez', 
    tipo_doc: 'cc' 
  };
  
  // Estado para mostrar cambios en tiempo real
  ultimoCambio: Record<string, unknown> = {};
  datosParaGuardar: Record<string, unknown> = {};
  estadoFormulario?: { valid: boolean; dirty: boolean; touched: boolean; };

  /**
   * Maneja el evento de envío del formulario
   */
  onGuardar(event: FormSubmitEvent): void {
    console.log('✅ Formulario enviado:', event);
    console.log('📋 Form ID:', event.formId);
    console.log('📊 Datos:', event.value);
    console.log('🕐 Timestamp:', event.timestamp);
    
    this.datosParaGuardar = event.value;
    
    // Aquí llamarías al servicio de API
    // this.contactoService.guardar(event.value).subscribe(...)
    
    alert(`Formulario "${event.formId}" enviado correctamente a las ${event.timestamp.toLocaleTimeString()}. Ver consola para detalles.`);
  }

  /**
   * Maneja los cambios en tiempo real del formulario
   */
  onCambio(event: FormChangeEvent): void {
    console.log('📝 Formulario cambió:', event);
    console.log('📋 Form ID:', event.formId);
    console.log('📊 Datos:', event.value);
    console.log('✅ Válido:', event.valid);
    console.log('📝 Modificado:', event.dirty);
    console.log('👆 Tocado:', event.touched);
    
    this.ultimoCambio = event.value;
    this.estadoFormulario = {
      valid: event.valid,
      dirty: event.dirty,
      touched: event.touched
    };
    
    // Aquí podrías implementar auto-guardado
    // si (event.dirty && event.valid) -> autoguardar después de debounce
  }

  /**
   * Maneja la cancelación del formulario
   */
  onCancelar(): void {
    console.log('❌ Formulario cancelado');
    
    // Resetear estado local
    this.ultimoCambio = {};
    this.datosParaGuardar = {};
    
    // Aquí podrías navegar a otra página
    // this.router.navigate(['/admin/contactos']);
    
    alert('Formulario cancelado');
  }
}